import cleanAuth from './cleanAuth'
import fgts from './fgts'
import formalization from './formalization'
import proposal from './proposal'

export default {
  proposal,
  formalization,
  cleanAuth,
  fgts
}
